import ProjectPromoCode from './ProjectPromoCode.vue'

export default ProjectPromoCode



// WEBPACK FOOTER //
// ./resources/assets/js/components/ProjectPromoCode/index.js